import { render, staticRenderFns } from "./editstandardorder.vue?vue&type=template&id=ac8c8bf2"
import script from "./editstandardorder.vue?vue&type=script&lang=js"
export * from "./editstandardorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports